import { Typography } from '@mui/material';
import { ORDER_STATUSES } from '@shared/api/constants';

export const TypographyOrderStatus = ({ status, variant = 'body2', sx = {} }) => {
    let color = 'textPrimary'; // Default color
    let text = '';

    if (!status) return <></>;

    switch (status) {
        case ORDER_STATUSES.RECEIVED:
            color = 'warning.main'; // Yellow for received
            text = 'received';
            break;
        case ORDER_STATUSES.COLLECTED:
            color = 'info.main'; // Blue for collected
            text = 'collected';
            break;
        case ORDER_STATUSES.SENT:
            color = 'success.main'; // Green for sent
            text = 'sent';
            break;
        default:
            text = '';
            break;
    }

    return (
        <Typography variant={variant} sx={{ color, ...sx }}>
            {text}
        </Typography>
    );
};

